import {
  AspectRatio,
  Box,
  HStack,
  IconButton,
  Link as ChakraLink,
  Text,
  Tooltip,
  VStack,
} from '@chakra-ui/react'
import numeral from 'numeral'
import { ReactElement, useState } from 'react'
import { AiOutlineLink } from 'react-icons/ai'
import { FiCopy, FiExternalLink } from 'react-icons/fi'
import type { Interceptors } from 'use-http'
import useFetch, { CachePolicies } from 'use-http'
import { colors } from '../../../ui-kit'
import type { ObjectOfBandwidthUrlAndViews } from '../../interfaces'
import AnalyticsFilePreview from './AnalyticsFilePreview'

const AnalyticsFileElement = ({
  bandwidth,
  url,
  thumbnailUrl,
  views,
  forceimagePreview
}: ObjectOfBandwidthUrlAndViews): ReactElement => {

  const [copiedUrl, setCopiedUrl] = useState<string | null>(null)

  const handleCopy = () => {
    void navigator.clipboard.writeText(url)
    setCopiedUrl(url)
    setTimeout(() => setCopiedUrl(null), 1800)
  }

  return (
    <VStack
      borderColor="appPaleLilac"
      borderWidth="1px"
      borderRadius="md"
      spacing={0}
      cursor="pointer"
      width="100%"
      overflow="hidden"
      justifyContent="flex-start"
      alignItems="flex-start"
      position="relative"
    >
      <AspectRatio width="100%" ratio={1 / 1}>
        <AnalyticsFilePreview url={url} thumbnailUrl={thumbnailUrl} forceimagePreview={forceimagePreview} />
      </AspectRatio>
      <VStack
        spacing={1}
        paddingX={2}
        paddingY={1}
        width="100%"
        justifyContent="flex-start"
        alignItems="flex-start"
      >
        <HStack spacing={0} width="full" justifyContent="space-between">
          <Text color="appSlate" fontSize="sm">
            {`${numeral(bandwidth).format('0.0ib').replace('i', '')}, ${numeral(
              views,
            )
              .format('0.0a')
              .toUpperCase()} requests`}
          </Text>
          <Box display="flex" alignItems="center" justifyContent="flex-end">
          <Tooltip closeDelay={200} label={copiedUrl === url ? 'Copied' : 'Copy URL'}>
            <IconButton
              aria-label="Copy URL"
              icon={<FiCopy />}
              size="sm"
              variant="ghost"
              color="appSlate"
              _hover={{ color: 'appBlue' }}
              onClick={handleCopy}
            />
          </Tooltip>
          <ChakraLink
            href={url}
            isExternal
            color="appSlate"
            _hover={{ color: 'appBlue' }}
          >
            <FiExternalLink />
          </ChakraLink>
          </Box>
        </HStack>
      </VStack>
    </VStack>
  )
}

export default AnalyticsFileElement
